import React from 'react';
import { Container, Section } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

import Visual from 'components/common/visual';
import Breadcrumbs from 'components/common/breadcrumbs';
import PageTitle from 'components/layout/pageTitle';
import BoardDetail from 'components/board/boardDetail';

// 행사안내 > 행사정보 상세 페이지
export default function EventDetail() {
  const pageName = '행사정보';
  const boardType = 'event';

  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <>
      <Visual category={boardType} title={pageName} />
      <Breadcrumbs />
      <Section p="0" pb={isMobile ? 'var(--space-18)' : 'var(--space-35)'} className={boardType}>
        <Container size={isMobile ? '1' : '4'}>
          <PageTitle icon={boardType} title={pageName} />
          <BoardDetail boardType={boardType} />
        </Container>
      </Section>
    </>
  );
}
